import React, { Suspense } from 'react';
import { Navigate } from "react-router-dom";

import LoadingSpinner from '@components/loading-spinner/LoadingSpinner';
import LazyLoadable from '@helpers/LazyLoadable';
import { lazy } from '@loadable/component';
import { ARCHEM_APPS } from '@src/app/pages/home/ArchemApps';
import ProtectedRoute from '@src/app/routes/ProtectedRoute';

const ReportLedgerDialog = LazyLoadable(lazy(() => import('./ReportLedger/ReportLedgerDialog')));
const MovementsEntryDialog = LazyLoadable(lazy(() => import('./terminal/movements/dialog/MovementsEntryDialog')));

const TanksFarmPage = LazyLoadable(lazy(() => import('./Tanks/farm/TanksFarmPage')))
const CalendardDashboard = LazyLoadable(lazy(() => import('./terminal/calendar-dashboard/CalendarDashboardCard')))
const DayEntry = LazyLoadable(lazy(() => import('./DayEntry/DayEntryPage')))
const PMSPage = LazyLoadable(lazy(() => import('./PMS/PMSMainPage')))
const MovementsEntryCard = LazyLoadable(lazy(() => import("./terminal/movements/card/MovementsEntryCard")));
const ReportsPage = LazyLoadable(lazy(() => import("./Reports/types/ReportTypePage")));
const ReportLedgerCard = LazyLoadable(lazy(() => import("./ReportLedger/ReportLedgerCard")));
const InventorySummaryPage = LazyLoadable(lazy(() => import("./InventorySummary/types/ReportTypePage")));

const HeightsCard = LazyLoadable(lazy(() => import("./Maintenance/height/HeightsCard")));
const SGCard = LazyLoadable(lazy(() => import("./Maintenance/sg/SGCard")));
const TankCard = LazyLoadable(lazy(() => import("./Maintenance/tanks/TanksCard")))
const FractionalCard = LazyLoadable(lazy(() => import("./Maintenance/fractional/FractionalCard")))
// const MovementsEntryDialog = LazyLoadable(lazy(() => import('./terminal/movements/dialog/MovementsEntryDialog'))); // dialog/MovementsEntryDialog

export const ROUTES_TANK_SOUNDING = [
  {
    path: "/tanksounding",
    element: <Suspense fallback={<LoadingSpinner />}> <ProtectedRoute module_name={ARCHEM_APPS.TANK_SOUNDING.module_name} /></Suspense>,
    children: [
      {
        index: true,
        element: <Navigate to="dashboard" />,
      },
      {
        path: "dashboard/*",
        element: <TanksFarmPage />,
        children: [
          {
            path: "reportledger",
            element: <ReportLedgerDialog show />
          }
        ]
      },
      {
        path: "calendardashboard",
        element: <CalendardDashboard />,
      },
      {
        path: "dayentry/:tid?/:tno?/:tcode?",
        element: <DayEntry />,
        meta: {
          abilities: [
            { action: 'day_entry_view', resource: 'Day Entry' },
            { action: 'day_entry_crud', resource: 'Day Entry' }
          ]
        }
      },
      {
        path: "pms",
        element: <PMSPage />,
        meta: {
          abilities: [
            { action: 'pms_view', resource: 'Product Movement Slip' },
            { action: 'pms_crud', resource: 'Product Movement Slip' }
          ]
        }
      },
      {
        path: "reports/*",
        element: <ReportsPage />,
        children: [
          {
            path: 'reportledger',
            element: <ReportLedgerDialog show={true} />

          }
        ]
      },
      {
        path: "reportledger",
        element: <ReportLedgerCard />
      },
      {
        path: 'inventorysummary',
        element: <InventorySummaryPage />
      },
      {
        path: "movements/filter/:dt/*",
        element: <MovementsEntryCard />,
        children: [
          {
            path: "new",
            element: <MovementsEntryDialog />
          },
          {
            path: "edit/:pws_id/:pws_movement_id",
            element: <MovementsEntryDialog />
          },
        ]
      },
      {
        path: "movements/*",
        element: <MovementsEntryCard />,
        children: [
          {
            path: "new",
            element: <MovementsEntryDialog />
          },
          {
            path: "edit/:pws_id/:pws_movement_id",
            element: <MovementsEntryDialog />
          },
        ],
        meta: {
          abilities: [
            { action: 'movements_view', resource: 'Movements' },
            { action: 'movements_crud', resource: 'Movements' }
          ]
        }
      },
      {
        path: "maintenance/height",
        element: <HeightsCard />,
      },
      {
        path: "maintenance/sg",
        element: <SGCard />,
      },
      {
        path: "maintenance/tanks",
        element: <TankCard />,
      },
      {
        path: "maintenance/fractional",
        element: <FractionalCard />,
      }
    ],
  }
];
